var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgencyAccreditation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75.394,
    height: 75.394,
    viewBox: "0 0 75.394 75.394",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10771",
    "data-name": "Group 10771",
    transform: "translate(-89.321 -1203.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10747",
    "data-name": "Group 10747",
    transform: "translate(-49.854 142.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search_results_for_Accreditation_-_Flaticon-3",
    "data-name": "Search results for Accreditation - Flaticon-3",
    transform: "translate(139.176 1060.946)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10746",
    "data-name": "Group 10746",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10398",
    "data-name": "Path 10398",
    d: "M61.445,1.356A1.213,1.213,0,0,0,60.585,1H28.969a1.216,1.216,0,0,0-1.216,1.216V53.289H26.072l.435-.871a11.855,11.855,0,0,0,1.245-5.275,6.124,6.124,0,0,0-.643-2.724,3.753,3.753,0,0,0-7.037.942,16.333,16.333,0,0,1-3.106,6.784L11.35,59.369h-.621V58.153a1.216,1.216,0,0,0-1.216-1.216h-7.3A1.216,1.216,0,0,0,1,58.153V75.178a1.216,1.216,0,0,0,1.216,1.216h7.3a1.216,1.216,0,0,0,1.216-1.216V73.4a24.382,24.382,0,0,0,9.086,1.778H31.4a3.646,3.646,0,0,0,2.717-6.08h41.06a1.216,1.216,0,0,0,1.216-1.216V16.808a1.211,1.211,0,0,0-.356-.86Zm.356,3.8L72.242,15.592H61.8ZM8.3,73.962H3.432V59.369H8.3ZM31.4,60.585a1.216,1.216,0,0,1,0,2.432,1.216,1.216,0,1,0,0,2.432,1.216,1.216,0,0,1,0,2.432,1.216,1.216,0,0,0,0,2.432,1.216,1.216,0,1,1,0,2.432H19.814a21.924,21.924,0,0,1-9.086-1.992V61.8h1.216a1.22,1.22,0,0,0,.961-.469l5.982-7.691a18.766,18.766,0,0,0,3.571-7.8,1.32,1.32,0,0,1,2.476-.332,3.672,3.672,0,0,1,.387,1.636,9.4,9.4,0,0,1-.989,4.187l-1.316,2.63A1.217,1.217,0,0,0,24.1,55.721h7.3a1.216,1.216,0,0,1,0,2.432,1.216,1.216,0,1,0,0,2.432Zm3.648,6.08a3.632,3.632,0,0,0-.931-2.432,3.641,3.641,0,0,0,0-4.864,3.646,3.646,0,0,0-2.717-6.08H30.185V3.432H59.369V16.808a1.216,1.216,0,0,0,1.216,1.216H73.962V66.665Z",
    transform: "translate(-1 -1)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10399",
    "data-name": "Path 10399",
    d: "M29.6,25.627l2.935-.978,1.9,1.9a1.214,1.214,0,0,0,.86.358,1.281,1.281,0,0,0,.28-.032,1.22,1.22,0,0,0,.874-.8l2.194-6.581c.1,0,.2.016.3.016s.2-.011.3-.016l2.194,6.581a1.22,1.22,0,0,0,.874.8,1.281,1.281,0,0,0,.28.032,1.218,1.218,0,0,0,.86-.356l1.9-1.9,2.936.978a1.215,1.215,0,0,0,1.5-1.646l-4.051-9.114a7.3,7.3,0,1,0-13.578,0L28.1,23.981a1.215,1.215,0,0,0,1.5,1.646Zm16.842-3.179-1.032-.343a1.213,1.213,0,0,0-1.244.293l-1.041,1.04-1.484-4.452a7.31,7.31,0,0,0,2.517-1.678Zm-7.5-15.1a4.864,4.864,0,1,1-4.864,4.864A4.869,4.869,0,0,1,38.944,7.349Zm-5.213,9.959a7.293,7.293,0,0,0,2.517,1.678l-1.484,4.452L33.724,22.4a1.211,1.211,0,0,0-1.244-.293l-1.032.343Z",
    transform: "translate(4.833 -0.154)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10400",
    "data-name": "Path 10400",
    d: "M53.512,39a8.512,8.512,0,1,0,8.512,8.512A8.522,8.522,0,0,0,53.512,39Zm0,14.592a6.08,6.08,0,1,1,6.08-6.08A6.087,6.087,0,0,1,53.512,53.592Z",
    transform: "translate(8.505 7.209)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10401",
    "data-name": "Path 10401",
    d: "M51.484,47.395l-1.471-1.471-1.719,1.719,2.432,2.432a1.21,1.21,0,0,0,.86.356l.067,0a1.218,1.218,0,0,0,.883-.454L57.4,43.9l-1.9-1.52Z",
    transform: "translate(9.217 7.938)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10402",
    "data-name": "Path 10402",
    d: "M27,25H61.049v2.432H27Z",
    transform: "translate(4.617 4.185)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10403",
    "data-name": "Path 10403",
    d: "M57,25h2.432v2.432H57Z",
    transform: "translate(11.098 4.185)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10404",
    "data-name": "Path 10404",
    d: "M27,29H61.049v2.432H27Z",
    transform: "translate(4.617 5.049)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10405",
    "data-name": "Path 10405",
    d: "M57,29h2.432v2.432H57Z",
    transform: "translate(11.098 5.049)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10406",
    "data-name": "Path 10406",
    d: "M27,33H61.049v2.432H27Z",
    transform: "translate(4.617 5.913)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10407",
    "data-name": "Path 10407",
    d: "M57,33h2.432v2.432H57Z",
    transform: "translate(11.098 5.913)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10408",
    "data-name": "Path 10408",
    d: "M27,37h2.432v2.432H27Z",
    transform: "translate(4.617 6.777)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10409",
    "data-name": "Path 10409",
    d: "M31,37H50.456v2.432H31Z",
    transform: "translate(5.481 6.777)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10410",
    "data-name": "Path 10410",
    d: "M27,41h2.432v2.432H27Z",
    transform: "translate(4.617 7.641)",
    fill: "#00641f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10411",
    "data-name": "Path 10411",
    d: "M31,41H46.808v2.432H31Z",
    transform: "translate(5.481 7.641)",
    fill: "#00641f"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencyAccreditation);
export default __webpack_public_path__ + "static/media/agencyAccreditation.a7de2d958fab407abd302e70b0eaa7b2.svg";
export { ForwardRef as ReactComponent };